import { ComponentProps, useId, useState } from 'react';

import { Paper } from '@mui/material';

import { Button, EditableSection, SectionHeader } from 'app/components';

import { useI18n } from 'i18n';

import EditAccountDomainsForm from './EditAccountDomainsForm';

interface AccountDomainsProps extends Omit<ComponentProps<typeof EditAccountDomainsForm>, 'formID'> {}

export default function AccountDomains({ onFormStateChange, ...props }: AccountDomainsProps) {
    const [disableEditCta, setDisableEditCta] = useState(false);
    const editFormID = useId();
    const { t } = useI18n();

    return (
        <Paper variant="outlined" sx={{ p: 4 }}>
            <EditableSection
                header={<SectionHeader title={t('admin_account_page.domains.heading')} />}
                saveCTA={<Button type="submit" form={editFormID} disabled={disableEditCta} />}
                disableAutoFocus
            >
                {({ isEditing }) => (
                    <EditAccountDomainsForm
                        {...props}
                        formID={editFormID}
                        hideSubmitCTA
                        readOnly={!isEditing}
                        onFormStateChange={event => {
                            const { shouldDisableCTA } = event;

                            setDisableEditCta(shouldDisableCTA);
                            onFormStateChange?.(event);
                        }}
                    />
                )}
            </EditableSection>
        </Paper>
    );
}
